import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function SMSConsent() {
  return (
    <div>
      <Header />
      <main style={{ padding: 24 }}>
        <h1>SMS Consent</h1>
        <p>Consent for SMS alerts. See /sms-consent.html for static version.</p>
      </main>
      <Footer />
    </div>
  );
}
